import auth from './modules/auth.json';
import components from './modules/components.json';
import qualityAssistant from './modules/qualityAssistant.json';
import jiraIntegration from './modules/jiraIntegration.json';
import testCycles from './modules/testCycles.json';
import missionControl from './modules/missionControl.json';
import personaGuide from './modules/personaGuide.json';
import safeChangeFlow from './modules/safeChangeFlow.json';
import translationLegacy from './translation.json';
// Import d'autres modules à venir...
// Force reload timestamp: 2025-10-07

export default {
  // Import des anciennes traductions comme base
  ...translationLegacy,
  
  // Clés de base (écrasent les anciennes si nécessaire)
  app: {
    title: "Nodemented",
    description: "Plateforme de gestion de connaissances par graphes",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    warning: "Attention",
    info: "Information"
  },
  
  // Modules (écrasent les anciennes si nécessaire)
  ...auth,
  ...components,
  qualityAssistant,
  ...jiraIntegration,
  testCycles,
  ...missionControl,
  ...personaGuide,
  ...safeChangeFlow,
  
  // Other sections to migrate progressively from translation.json
  navigation: {
    dashboard: "Retour au Dashboard",
    nodes: "Nœuds",
    relationships: "Créer des Relations",
    search: "Recherche",
    profile: "Profil",
    settings: "Paramètres",
    admin: "Administration",
    help: "Aide",
    about: "À propos",
    // Nouvelles clés pour la navigation refactorisée
    sections: "Sections du Laboratoire",
    sectionsDesc: "Créer facilement votre documentation détaillée, ses relations, et les tests associés ! Analysez la couverture de vos tests et générez des spécifications avec l'IA.",
    primarySections: "Sections Principales",
    advancedSections: "Sections Avancées",
    selectedNode: "Nœud sélectionné",
    createNode: "Créer / Modifier un Nœud",
    createNodeDesc: "Créer ou modifier un nœud",
    nodesList: "Liste des Nœuds",
    nodesListDesc: "Parcourir tous les nœuds",
    relations: "Relations",
    relationsDesc: "Gérer les relations entre nœuds",
    tests: "Tests",
    testsDesc: "Gérer et visualiser les tests",
    importCode: "Import de Code",
    importCodeDesc: "Créer des nœuds depuis du code",
    quickCreate: "Création Rapide",
    quickCreateDesc: "Créez facilement des nœuds et des relations en langage naturel grâce à l'IA",
    vectorSearch: "Assistant Qualité & Recherche Vectorielle",
    vectorSearchDesc: "Analyser et Rechercher dans la base de connaissances",
    analysis: "Couverture des Tests",
    analysisDesc: "Rapport détaillé de couverture des tests",
    specifications: "Spécifications IA",
    specificationsDesc: "Créer & Gérer vos spécifications avec l'IA",
    jiraImport: "Import JIRA",
    jiraImportDesc: "Importez vos tickets JIRA et générez automatiquement des nœuds avec l'IA"
  },
  
  // Traductions pour l'interface mobile du laboratoire
  mobileLabView: {
    tabs: {
      nodes: "Nœuds",
      create: "Créer",
      relations: "Relations",
      tests: "Tests",
      graph: "Graphique"
    },
    searchNodes: "Rechercher un nœud...",
    nodesFound: "nœuds trouvés",
    relations: "relations",
    createRelation: "Créer une relation",
    testsFor: "Tests pour {{nodeName}}",
    runTests: "Lancer les tests",
    backToNodes: "Retour aux nœuds",
    selectNodeFirst: "Sélectionnez d'abord un nœud pour voir ses détails",
    browseNodes: "Parcourir les nœuds",
    mobileOptimized: "Interface optimisée pour mobile",
    swipeHint: "Balayez pour naviguer entre les sections",
    
    // Version simplifiée
    viewOnlyMode: "Mode consultation",
    editOnDesktop: "Pour modifier, utilisez la version desktop",
    graphVisualization: "Visualisation du graphique",
    graphDescription: "Explorez vos nœuds et relations de manière interactive",
    nodesOverview: "Aperçu des nœuds",
    relationshipsOverview: "Aperçu des relations",
    testsOverview: "Aperçu des tests",
    testResults: "Résultats des tests"
  },
  
  // Traductions pour la création mobile de nœuds
  mobileCreateNode: {
    title: "Créer un nouveau nœud",
    basicInfo: "Informations de base",
    advancedInfo: "Informations avancées",
    nodeName: "Nom du nœud",
    nodeNamePlaceholder: "Saisissez le nom du nœud...",
    nodeType: "Type de nœud",
    selectType: "Sélectionnez un type",
    description: "Description",
    descriptionPlaceholder: "Décrivez la fonctionnalité ou l'objectif...",
    technology: "Technologie",
    selectTechnology: "Sélectionnez une technologie",
    featureTeam: "Équipe Feature",
    featureTeamPlaceholder: "Ex : Team Frontend, Squad Mobile...",
    featureTeamHint: "Permet de regrouper les nœuds par équipe dans le graphe",
    status: "Statut",
    selectStatus: "Sélectionnez un statut",
    metadata: "Métadonnées (JSON)",
    metadataPlaceholder: "{\n  \"priority\": \"high\",\n  \"category\": \"frontend\"\n}",
    jsonFormat: "Format JSON valide requis",
    advancedOptions: "Options avancées",
    createNode: "Créer le nœud",
    creating: "Création...",
    back: "Retour",
    reset: "Réinitialiser",
    nameRequired: "Le nom du nœud est requis"
  },
  
  // GraphSection navigation and filters
  graphSection: {
    title: "Visualisation du Graphe",
    description: "Explorez vos nœuds et leurs relations de manière interactive",
    expandFilter: "Développer le filtre",
    collapseFilter: "Réduire le filtre", 
    hideFilter: "Masquer le Filtre"
  },
  
  // Traductions pour le graphique mobile
  mobileGraph: {
    searchNodes: "Rechercher dans le graphique...",
    zoomIn: "Zoom avant",
    zoomOut: "Zoom arrière",
    fitView: "Ajuster à la vue",
    fullscreen: "Plein écran",
    exitFullscreen: "Quitter le plein écran",
    nodes: "nœuds",
    relations: "relations",
    found: "trouvés",
    labels: "Libellés",
    physics: "Physique",
    loading: "Chargement du graphique...",
    noData: "Aucune donnée à afficher",
    createNodesFirst: "Créez des nœuds pour voir le graphique",
    graphView: "Vue graphique",
    interactiveMode: "Mode interactif",
    staticMode: "Mode statique"
  }
};
